import { typedFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import { getUnlinkCustomerHostifyUrl } from "./api-url.constants";
import { UnlinkCustomerHostifyError } from "./errors";

export const unlinkCustomerHostify = async (userId?: string): Promise<void> => {
  const response = await typedFetch(getUnlinkCustomerHostifyUrl(userId), {
    method: API_METHODS.DELETE,
  });

  if (!response.ok) throw new UnlinkCustomerHostifyError();
};
